module.exports = __webpack_public_path__ + "img/img_C2.6.c5d52ffc.png";